export default {
  "content": "<path d=\"M11.38 8.313V6.78A1.969 1.969 0 009.41 4.813h-.875a.656.656 0 01-.656-.657v-.875A1.969 1.969 0 005.91 1.312H4.817m0 7.438h4.375M4.817 10.5h2.188M6.13 1.312H3.286a.656.656 0 00-.656.657V12.03c0 .363.294.656.656.656h7.438a.656.656 0 00.656-.656V6.562c0-2.899-2.35-5.25-5.25-5.25z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "14",
    "viewBox": "0 0 14 14",
    "fill": "none"
  }
};